import React, { ReactNode } from 'react';

export const InBrowser = ({ children }: { children: ReactNode }) =>
	__IS_SERVER__ ? null : <>{children}</>;
export const AtServer = ({ children }: { children: ReactNode }) =>
	__IS_SERVER__ ? <>{children}</> : null;
